import {
  STORAGE_KEY,
  cdnUrl,
  defaultColor,
  defaultDirection,
  defaultLocale,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
} from '~/constants';

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem(STORAGE_KEY.DIRECTION)) {
      const localValue = localStorage.getItem(STORAGE_KEY.DIRECTION);
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.error('>>>>: src/helpers/utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};

export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem(STORAGE_KEY.DIRECTION, direction);
  } catch (error) {
    console.error('>>>>: src/helpers/utils.js : setDirection -> error', error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : getCurrentColor -> error',
      error,
    );
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : setCurrentColor -> error',
      error,
    );
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'rounded';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : getCurrentRadius -> error',
      error,
    );
    currentRadius = 'rounded';
  }
  return currentRadius;
};

export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : setCurrentRadius -> error',
      error,
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language = localStorage.getItem(STORAGE_KEY.CURRENT_LANGUAGE)
      && localeOptions.filter(
        (x) => x.id === localStorage.getItem(STORAGE_KEY.CURRENT_LANGUAGE),
      ).length > 0
      ? localStorage.getItem(STORAGE_KEY.CURRENT_LANGUAGE)
      : defaultLocale;
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : getCurrentLanguage -> error',
      error,
    );
    language = defaultLocale;
  }
  return language;
};

export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem(STORAGE_KEY.CURRENT_LANGUAGE, locale);
  } catch (error) {
    console.error(
      '>>>>: src/helpers/utils.js : setCurrentLanguage -> error',
      error,
    );
  }
};

export const openCdnPopup = (area, type = '', multiple = false, callback = null) => {
  const onMessage = (e) => {
    if (!e.data) {
      return;
    }

    if (e.data.area === area) {
      if (e.data.url) {
        callback(e.data.url);
      } else if (e.data.data) {
        const urls = JSON.parse(e.data.data);
        callback(urls.map((a) => a.url));
      }
    }
  };

  let url = `${cdnUrl}&area=${area}&popup=${multiple ? 'multiple' : 'single'}`;
  if (type) {
    url += `&type=${type}`;
  }

  const width = Math.min(1000, window.innerWidth - 40);
  const height = Math.min(800, window.innerHeight - 40);
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;
  const feature = `resizable=yes, width=${width}, height=${height}, top=${top}, left=${left}`;

  const win = window.open(url, 'PopupCDN', feature);

  if (callback) {
    window.addEventListener('message', onMessage);

    const timer = setInterval(() => {
      if (win.closed) {
        clearInterval(timer);

        setTimeout(() => {
          window.removeEventListener('message', onMessage);
        }, 1000);
      }
    }, 100);
  }
};
